import { jsx } from "react/jsx-runtime";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { validateTidalLicense } from "../../base/index.js";
function ListAlt(props) {
  return /* @__PURE__ */ jsx(
    ListAltIcon,
    {
      "data-testid": "ListAlt",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ListAlt",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
ListAlt.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "ListAlt"
};
validateTidalLicense();
export {
  ListAlt
};
//# sourceMappingURL=ListAlt.js.map
